import { siteStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="w-full px-4 md:px-6 py-10 md:py-16">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              <span>实时热点 · 真实内幕</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-display text-foreground-950 leading-tight mb-4">
              吃瓜爆料
              <span className="block text-2xl md:text-4xl lg:text-5xl text-foreground-800 mt-1">
                真实娱乐资讯第一站
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-sans mb-4 max-w-[640px] mx-auto lg:mx-0 leading-relaxed">
              全网最快最全的吃瓜爆料平台，聚焦娱乐圈真实内幕与热点追踪。
            </p>
            <p className="text-sm md:text-base text-foreground-500 font-sans mb-8 max-w-[640px] mx-auto lg:mx-0 leading-relaxed">
              每日50+条独家爆料实时更新，覆盖明星动态、综艺黑幕、影视内幕、网红翻车、资本暗战等全维度娱乐资讯。
              多源交叉验证确保内容真实可靠，匿名投稿机制保护爆料人隐私安全。
              当前热点聚焦：某顶流歌手税务风波持续发酵、选秀节目导师受贿疑云、影视公司财报曝天价片酬。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-3xl font-display text-primary-500">{siteStats.totalArticles}</div>
                <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-3xl font-display text-accent-500">{siteStats.dailyUpdates}</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-3xl font-display text-secondary-500">{siteStats.activeUsers}</div>
                <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-flashlight-line w-4 h-4 flex items-center justify-center"></i>
                查看今日热点
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-md hover:border-primary-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center"></i>
                匿名投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/5] lg:aspect-[3/4] overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20for%20entertainment%20gossip%20news%20platform%2C%20warm%20coral%20red%20and%20deep%20amber%20color%20palette%2C%20dramatic%20spotlight%20effect%20on%20newspaper%20headlines%20and%20magnifying%20glass%2C%20abstract%20geometric%20composition%2C%20modern%20magazine%20cover%20aesthetic%2C%20clean%20minimal%20background%20with%20soft%20gradients%2C%20artistic%20conceptual%20design%20with%20news%20and%20investigation%20theme&width=600&height=750&seq=hero-main-01&orientation=portrait"
                alt="吃瓜爆料平台主视觉 - 娱乐资讯与真实内幕"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}